<template>
  <v-row>
    <users-list
      @addUserClick="addUserClick()"
      @editUserClick="editUserClick"
      @deleteUserClick="deleteUserClick($event)"
      @loadData="loadData($event)"
      :users="data"
      :usersLoading="entityLoading"
      :totalUsers="totalCount"
    ></users-list>

    <notifications group="user-form-success" position="top center" />
    <v-dialog v-model="isEditUser" persistent :max-width="dialogWidth">
      <EditUserForm
        v-if="isEditUser"
        :user-id="user?.id"
        :all-corporations="allCorporations"
        @closeDialog="onEditUserClose"
      />
    </v-dialog>

    <v-dialog v-model="isAddUser" persistent :max-width="dialogWidth">
      <CreateUserForm
        v-if="isAddUser"
        :all-corporations="allCorporations"
        @closeDialog="onAddUserClose"
      />
    </v-dialog>

    <dialog-wrapper
      ref="userCommonDialog"
      :width="dialogWidth"
      @closeDialog="closeDialog"
    />
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import DialogWrapper from '@/components/elements/DialogWrapper.vue';
import UsersList from '@/components/users/UsersList.vue';
import { entityLoader } from '@/mixins/entityLoader.mixins';
import EditUserForm from "./forms/EditUserForm.vue";
import CreateUserForm from "./forms/CreateUserForm.vue";
import _ from "lodash";

export default {
  name: 'list-users-view',
  components: {
    UsersList,
    EditUserForm,
    CreateUserForm,
    DialogWrapper,
  },
  mixins: [
    entityLoader,
  ],
  data() {
    return {
      user: null,
      mode: 'add',
      dialogWidth: 600,
      corporations: [],
      corporationsLoading: false,
      completeCorporationsList: [],
      debouncedListCorporations: null,
      isEditUser: false,
      isAddUser: false,
      allCorporations: [],
      localSort: '-createdAt',
    };
  },
  computed: {
    ...mapGetters('accountsApiStore', ['accountsList', 'accountSelected']),
    totalCount() {
      return this.entityTotalCount.totalCount;
    },
  },
  async created() {
    // This is needed to have the corporations list ready for the user form to display the corporation's information.
    // const { data } = await this.$store.dispatch('corporations/listCorporations', { sort: 'name', maxPerPage: Number.MAX_SAFE_INTEGER });
    // this.completeCorporationsList = data;
    this.debouncedListCorporations = _.debounce(this.listCorporations, 500);
  },
  methods: {
    async listCorporations(value) {
      this.corporationsLoading = true;
      const { data } = await this.$store.dispatch('corporations/listCorporations', {sort: 'name', name: value, maxPerPage: 10 });
      this.corporations = data;
      this.corporationsLoading = false;
    },
    async addUserClick() {
      this.mode = 'add';
      const { data } = await this.$store.dispatch('corporations/loadAllCorporations');

      this.allCorporations = data;
      this.isAddUser = true;

    },
    async onAddUserClose() {
      this.isAddUser = false;

      await this.loadData({
        ...this.entitySearchObject,
        page: 0,
        corporationId: this.accountSelected,
        sort: this.localSort,
      });
    },
    async onEditUserClose() {
      this.isEditUser = false;

      await this.loadData({
        ...this.entitySearchObject,
        page: 0,
        corporationId: this.accountSelected,
        sort: this.localSort,
      });
    },
    async editUserClick(user) {
      this.user = user;

      const { data } = await this.$store.dispatch('corporations/loadAllCorporations');

      this.allCorporations = data;
      this.isEditUser = true;
    },
    closeDialog(submitted) {
      this.$refs.userCommonDialog.close();

      if (submitted) {
        this.loadData({
          ...this.entitySearchObject,
          page: 0,
          corporationId: this.accountSelected,
          sort: '-createdAt',
        });
      }
    },
    async deleteUserClick(users) {
      this.dialogWidth = 400;
      this.$refs.userCommonDialog.openDialog({ type: 'delete-business-user', id: users.id });
    },
    async loadData({
      sort, page, maxPerPage, dynamicSearch, corporationId,
    }) {

      this.localSort = sort;
      const params = {
        page,
        maxPerPage,
        sort,
        dynamicSearch,
        corporationId,
      };

      await this.getList('users/listUsers', params);
    },
  },
};
</script>